import Loader from "components/blocks/Loader/Loader";

import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useGetShortener from "services/shortener/useGetShortener";
import { safeRedirect } from "../../../utils/security";

const Shortener: React.FC = () => {
  const { url } = useParams<{ url: string }>();
  const {
    getShortenerOriginalUrl,
    successGetShortenerPage,
    errorGetShortenerPage,
    shortenerPage,
  } = useGetShortener();
  useEffect(() => {
    if (url) {
      getShortenerOriginalUrl(url);
    }
  }, [url]);

  useEffect(() => {
    if (!shortenerPage) return;
    safeRedirect(shortenerPage);
  }, [shortenerPage]);
  return (
    <>
      <Loader></Loader>
      </>
  );
};
export default Shortener;
